module.exports = __webpack_public_path__ + "static/media/solutionpage4.d005ca0d.png";